import React, { memo, useCallback } from 'react';
import { useTranslation } from "react-i18next"; 
import Box from '@mui/material/Box';
import Checkbox from '@mui/material/Checkbox';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead'; 
import TableRow from '@mui/material/TableRow';
import TextField from '@mui/material/TextField';  
import Typography from '@mui/material/Typography';  
import "css/customDialog.css";

const ProductRow = memo(({ item, index, i18n, onChangeNO, onChangeWeight, onChangeSpare, onChangeResidue, onSelectNo, onSelectWeight, onSelectSpare, onSelectResidue }) => {
  return (
    <TableRow>
      <TableCell align="left">
        <Typography style={{color:"#4e73df", fontSize: 18}} >
          {i18n.language==='es' ? item.product_namees : item.product_nameen}
        </Typography>
      </TableCell>      
      {/* NO */}
      <TableCell align="center" sx={{ fontSize: '12px' }}>
        <TextField
          type="number"
          size="small"
          value={item.amountNo || 0}
          onChange={(e) => onChangeNO(index, e.target.value)}
          inputProps={{ min: 0 }}
          sx={{ width: '100%'}}
        />
      </TableCell>
      <TableCell align="center" sx={{ fontSize: '12px' }}>
        <Checkbox
          checked={item.isSelectedNo || false}
          onChange={() => onSelectNo(index)}
        />
      </TableCell>

      {/* PESO */}
      <TableCell align="center" sx={{ fontSize: '12px' }}>
        <TextField
          type="number"
          size="small"
          value={item.amountWeight || 0}
          onChange={(e) => onChangeWeight(index, e.target.value)}
          inputProps={{ min: 0 }}
          sx={{ width: '100%' }}
        />
      </TableCell>
      <TableCell align="center" sx={{ fontSize: '12px' }}>
        <Checkbox
          checked={item.isSelectedWeigth || false}
          onChange={() => onSelectWeight(index)}
        />
      </TableCell>

      {/* REPUESTOS */}
      <TableCell align="center" sx={{ fontSize: '12px' }}>
        <TextField
          type="number"
          size="small"
          value={item.amountSpare || 0}
          onChange={(e) => onChangeSpare(index, e.target.value)}
          inputProps={{ min: 0 }}
          sx={{ width: '100%'}}
        />
      </TableCell>
      <TableCell align="center" sx={{ fontSize: '12px' }}>
        <Checkbox
          checked={item.isSelectedSpare || false}
          onChange={() => onSelectSpare(index)}
        />
      </TableCell>

      {/* RESIDUO */}
      <TableCell align="center" sx={{ fontSize: '12px' }}>
        <TextField
          type="number"
          size="small"
          value={item.amountResidue || 0}
          onChange={(e) => onChangeResidue(index, e.target.value)}
          inputProps={{ min: 0 }}
          sx={{ width: '100%' }}
        />
      </TableCell>
      <TableCell align="center" sx={{ fontSize: '12px' }}>
        <Checkbox
          checked={item.isSelectedResidue || false}
          onChange={() => onSelectResidue(index)}
        />
      </TableCell>
    </TableRow>
  );
});

const TableSortingProduct = memo(({ productLinesheet, setProductLinesheet }) => {
  const {t,i18n} = useTranslation(['listDataForms']);

  const handleAmountChangeNO = useCallback((i, val) => {
    const value = Number(val);
    setProductLinesheet((prev) => {
      const newData = [...prev];
      newData[i] = { 
        ...newData[i], 
        amountNo: value,
       isSelectedNo: value > 0  // activamos/desactivamos automáticamente
      };
      return newData;
    });
  }, [setProductLinesheet]);

  const handleAmountChangeWeight = useCallback((i, val) => {
    const value = Number(val);
    setProductLinesheet((prev) => {
      const newData = [...prev];
      newData[i] = { 
        ...newData[i], 
        amountWeight: value,
       isSelectedWeigth: value > 0
      };
      return newData;
    });
  }, [setProductLinesheet]);

  const handleAmountChangeSpare = useCallback((i, val) => {
    const value = Number(val);
    setProductLinesheet((prev) => {
      const newData = [...prev];
      newData[i] = { 
        ...newData[i], 
        amountSpare: value,
       isSelectedSpare: value > 0
      };
      return newData;
    });
  }, [setProductLinesheet]);

  const handleAmountChangeResidue = useCallback((i, val) => {
    const value = Number(val);
    setProductLinesheet((prev) => {
      const newData = [...prev];
      newData[i] = { 
        ...newData[i], 
        amountResidue: value,
       isSelectedResidue: value > 0
      };
      return newData;
    });
  }, [setProductLinesheet]);
 
  const handleSelectChangeNo = useCallback((i) => {
    setProductLinesheet((prev) => {
      const newData = [...prev];
      newData[i] = { 
        ...newData[i], 
        isSelectedNo: !newData[i].isSelectedNo 
      };
      return newData;
    });
  }, [setProductLinesheet]);

  const handleSelectChangeWeight = useCallback((i) => {
    setProductLinesheet((prev) => {
      const newData = [...prev];
      newData[i] = { 
        ...newData[i], 
        isSelectedWeigth: !newData[i].isSelectedWeigth 
      };
      return newData;
    });
  }, [setProductLinesheet]);

  const handleSelectChangeSpare = useCallback((i) => {
    setProductLinesheet((prev) => {
      const newData = [...prev];
      newData[i] = { 
        ...newData[i], 
        isSelectedSpare: !newData[i].isSelectedSpare 
      };
      return newData;
    });
  }, [setProductLinesheet]);

  const handleSelectChangeResidue = useCallback((i) => {
    setProductLinesheet((prev) => {
      const newData = [...prev];
      newData[i] = { 
        ...newData[i], 
        isSelectedResidue: !newData[i].isSelectedResidue 
      };
      return newData;
    });
  }, [setProductLinesheet]);

  return (
    <Box sx={{ width: '100%' }}>
      <TableContainer component={Paper} className="formdi-table-container" style={{ height: '100%' }}>
        <Table sx={{ minWidth: '100%' }} stickyHeader size="small"  aria-labelledby="tableTitle"> 
          <TableHead>
            <TableRow>
              <TableCell sx={{ width: '20%' }} align="left">
                <Typography style={{color:"#4e73df", fontSize: 18}} >
                  {t('Text_SHEET_PRODUCT').toUpperCase()}
                </Typography>
              </TableCell> 
              <TableCell sx={{ width: '15%'}} align="center">
                 <Typography style={{color:"#4e73df", fontSize: 18}} >
                  {t('Text_SHEET_NO').toUpperCase()}
                </Typography>
              </TableCell>
              <TableCell sx={{ width: '5%'}} align="center">
                <Typography style={{color:"#4e73df", fontSize: 18}} >
                  {t('Text_SHEET_SELECT').toUpperCase()}
                </Typography>
              </TableCell> 
              <TableCell sx={{ width: '15%'}} align="center">
                <Typography style={{color:"#4e73df", fontSize: 18}} >
                  {t('Text_SHEET_WEIGHT').toUpperCase()}
                </Typography>
              </TableCell> 
              <TableCell sx={{ width: '5%'}} align="center">
                <Typography style={{color:"#4e73df", fontSize: 18}} >
                  {t('Text_SHEET_SELECT').toUpperCase()}
                </Typography>
              </TableCell> 
              <TableCell sx={{ width: '15%'}} align="center">
                <Typography style={{color:"#4e73df", fontSize: 18}} >
                  {t('Text_SHEET_REP').toUpperCase()}
                </Typography>
              </TableCell> 
              <TableCell sx={{ width: '5%'}} align="center">
                <Typography style={{color:"#4e73df", fontSize: 18}} >
                  {t('Text_SHEET_SELECT').toUpperCase()}
                </Typography>
              </TableCell> 
              <TableCell sx={{ width: '15%'}} align="center">
                <Typography style={{color:"#4e73df", fontSize: 18}} >
                  {t('Text_SHEET_RESIDUE').toUpperCase()}
                </Typography>
              </TableCell> 
              <TableCell sx={{ width: '5%'}} align="center">
                <Typography style={{color:"#4e73df", fontSize: 18}} >
                  {t('Text_SHEET_SELECT').toUpperCase()}
                </Typography>
              </TableCell> 
            </TableRow>
          </TableHead>
          <TableBody>
            {productLinesheet.map((item, index) => (
              <ProductRow
                key={index}
                item={item}
                index={index}
                i18n={i18n}
                onChangeNO={handleAmountChangeNO}
                onChangeWeight={handleAmountChangeWeight}
                onChangeSpare={handleAmountChangeSpare}
                onChangeResidue={handleAmountChangeResidue}
                onSelectNo={handleSelectChangeNo}
                onSelectWeight={handleSelectChangeWeight}
                onSelectSpare={handleSelectChangeSpare}
                onSelectResidue={handleSelectChangeResidue}
              />
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
});

export default TableSortingProduct;
